import { ThemeUICSSObject, getColorsByPath } from '@apia/theme';
/* IMPORT HERE */

const defaultAccordion: ThemeUICSSObject = {
  boxShadow: 'default',
  border: 'none',
  width: '100%',

  '&>button': {
    variant: 'buttons.accordion',
    fontSize: 18,
  },
  ...getColorsByPath('accordion'),
  /* PREPEND HERE */
  '.responsiveTable__accordionElement__toggler': {
    alignItems: 'center',
  },

  '.checkbox': {
    flexShrink: 0,
  },
  '&.global .accordionElement__toggler__label': {
    fontWeight: 'bold',
  },
  '&:not(.global) .accordionElement__toggler__label': {
    fontWeight: 'normal',
  },

  '&.light': {
    '.accordionElement__toggler__label': {
      fontWeight: 'normal',
    },
  },
};

export default defaultAccordion;
